if (typeof jQuery !== "undefined") {
    (function($) {
        /** Collectivity autocomplete
         *
         * Autocomplete for collectivity dropdown
         * Makes use of jQuery UI (1.9.2) Autocomplete
         *
         */
        ZZ.CollectivityAutocomplete = function(input) {
            var base = this;
            base.input = input;
            base.hiddenInput = $('<input type="hidden" />');
            base.submitBtn = base.input
                .parents("form:first")
                .find("[type=submit]");
            base.url = base.input.attr("data-url");
            base.requiredField = base.input.attr("data-required-field");
            base.columns = base.input.attr("data-columns").split(" ") || [];
            base.warning = $("#collectivity_warning");
            base.warningDefaultText = base.warning.text();
            base.warning.state = "hidden";
            base.response = { content: [] };
            base.selectedFromList = false;
            base.autocomplete = base.input.autocomplete({
                source: base.url,
                minLength: 1,
                delay: 500
            });

            // disable submit button on init, if the collectivity search is visible, and is the only function of the form
            if (
                base.requiredField &&
                base.input.is(":visible") &&
                base.input.closest("form").find("fieldset").length === 1
            ) {
                base.submitBtn.prop("disabled", true);
                base.submitBtn.addClass("disabledByCollectivityAutocomplete");
            }

            // get next form rows for info
            var formRow = base.input.closest(".form-row");
            base.nextFormRows = formRow.find("~ .form-row");

            base.collectivityDiscountChoice = $("#collectivity_discount_choice");
            base.collectivityName = $("#name");
            base.collectivityMessage = $("[data-collectivity-message]");

            // override _renderItem function to make multiple column layout possible in autocomplete dropdown
            base.autocomplete.data("autocomplete")._renderItem = function(
                ul,
                item
            ) {
                return $("<li></li>")
                    .data("item.autocomplete", item)
                    .append(
                        "<a><div>" +
                            item.label +
                            " </div><div>" +
                            item.value +
                            " </div></a>"
                    )
                    .appendTo(ul);
            };

            base.assignListeners();
        };

        ZZ.CollectivityAutocomplete.prototype = {
            assignListeners: function() {
                var base = this;

                base.input.on("keypress", function(e) {
                    if (e.which !== 0 && e.charCode !== 0) {
                        // don't act on non-printable characters
                        base.warning.hide();
                        base.nextFormRows.hide();
                        base.warning.state = "hidden";
                    }
                });

                base.autocomplete.on("autocompleteresponse", function(
                    event,
                    ui
                ) {
                    base.response = ui;
                    base.selectedFromList = false;
                    if (
                        base.input.val().length >= 3 &&
                        (!ui.content || ui.content.length === 0)
                    ) {
                        base.warning.html(base.warningDefaultText).fadeIn(150);
                        base.warning.state = "visible";
                        base.nextFormRows.hide();
                    } else if (
                        typeof ui.content !== "undefined" &&
                        typeof ui.content[0] !== "undefined" &&
                        typeof ui.content[0].errorType !== "undefined"
                    ) {
                        var message =
                            ui.content[0].errorMessage ||
                            base.warningDefaultText;
                        base.warning
                            .html(
                                '<p class="notification-block__message">' +
                                    message +
                                    "</p>"
                            )
                            .fadeIn(150);
                        base.warning.state = "visible";
                        base.nextFormRows.hide();
                        base.input.autocomplete("close");
                        base.submitBtn.prop("disabled", true);
                        base.submitBtn.addClass(
                            "disabledByCollectivityAutocomplete"
                        );
                    } else {
                        base.warning.hide();
                        base.warning.state = "hidden";
                    }
                });

                base.autocomplete.on("autocompleteopen", function() {
                    if (base.columns.length > 0) {
                        var columns = $('<li class="columnheader"></li>');
                        for (var i = 0; i < base.columns.length; i++) {
                            columns.append(
                                "<div>" + base.columns[i] + "</div>"
                            );
                        }
                        $(".ui-autocomplete").prepend(columns);
                    }
                });

                base.autocomplete.on("autocompleteclose", function(event) {
                    // auto-select item if number is existing collectivity number
                    if (!base.selectedFromList) {
                        var items = base.response.content,
                            itemsLength = items.length,
                            value = base.input.val(),
                            i,
                            curItem;

                        for (i = 0; i < itemsLength; i++) {
                            curItem = items[i];
                            if (curItem.value === value) {
                                base.selectItem(event, { item: curItem });
                                break;
                            }
                        }
                    }

                    base.input.trigger("blur.validate");
                });

                // custom event triggered by formvalidation.js
                base.input.on("ZZ_validate_done", function() {
                    if (base.input.parent().hasClass("error")) {
                        base.warning.html(base.warningDefaultText).fadeIn(150);
                        base.warning.state = "visible";
                    } else if (
                        base.warning.state === "visible" &&
                        base.warning.html() === base.warningDefaultText
                    ) {
                        base.warning.hide();
                        base.warning.state = "hidden";
                    }
                });

                base.autocomplete.on("autocompleteselect", function(event, ui) {
                    base.selectedFromList = true;
                    base.selectItem(event, ui);
                });

                base.collectivityDiscountChoice.on("change", function(event) {
                    if (event.target.value === "no") {
                        base.collectivityMessage.addClass("is-hidden")
                    }
                })

                $(window).on("ZZ_form-interaction", function() {

                    var currentCollectivity = $("[data-current-collectivity]");
                    var currentCollectivityName = currentCollectivity.attr("data-current-collectivity");

                    if (!base.input.is(":visible")) {
                        base.warning.hide(0);
                        base.warning.state = "hidden";

                        $("[data-collectivity-output]").text("");

                        if (currentCollectivityName && base.collectivityDiscountChoice.val() !== "no") {
                            $("[data-collectivity-output]").text(currentCollectivityName);
                            currentCollectivity.removeClass("is-hidden");
                        }

                        base.nextFormRows.hide();
                        base.submitBtn.removeClass(
                            "disabledByCollectivityAutocomplete"
                        );
                    } else if (base.warning.state === "visible") {
                        base.warning.show(0);
                    }
                });
            },

            selectItem: function(event, ui) {
                var base = this;

                base.hiddenInput.val(ui.item.value);
                $("[data-collectivity-output]").text(ui.item.label);
                base.warning.hide();
                base.warning.state = "hidden";

                if (
                    typeof ui.item.message !== "undefined" &&
                    ui.item.message !== ""
                ) {
                    base.warning.html(
                        '<p class="notification-block__message">' +
                            ui.item.message +
                            "</p>"
                    );
                    base.warning.show();
                    base.warning.state = "visible";

                    if (ui.item.online) {
                        base.warning.removeClass("notification-block--warning");
                        base.warning.addClass(
                            "notification-block--informative"
                        );
                    } else {
                        base.warning.removeClass(
                            "notification-block--informative"
                        );
                        base.warning.addClass("notification-block--warning");
                    }
                }
                if (ui.item.online) {
                    base.submitBtn.removeClass(
                        "disabledByCollectivityAutocomplete"
                    );
                    if (
                        base.submitBtn.attr("class").indexOf("disabledBy") ===
                        -1
                    ) {
                        base.submitBtn.prop("disabled", false);
                    }
                    base.nextFormRows
                        .find(":input:visible")
                        .prop("disabled", false);
                    base.nextFormRows.show();

                    if (base.collectivityDiscountChoice.val() === "yes" && base.collectivityName.val() !== "") {
                        base.collectivityMessage.removeClass("is-hidden")
                    }
                } else {
                    // disable submit button on init, if the collectivity search is visible, and is the only function of the form
                    // or if collectivity is not available for online application
                    if (
                        (base.requiredField &&
                            base.input.is(":visible") &&
                            base.input.closest("form").find("fieldset")
                                .length === 1) ||
                        (typeof ui.item.online !== "undefined" &&
                            ui.item.introductieKorting.toString() === "false")
                    ) {
                        base.submitBtn.prop("disabled", true);
                        base.submitBtn.addClass(
                            "disabledByCollectivityAutocomplete"
                        );
                    }

                    var formRow = base.input.closest(".form-row");
                    base.nextFormRows.hide();
                    formRow.next().show();
                }

                var introElem = $(
                    base.nextFormRows.filter(".introduction-question")
                );
                if (
                    typeof ui.item.introductieKorting !== "undefined" &&
                    ui.item.introductieKorting.toString() === "true"
                ) {
                    introElem.find(":input").prop("disabled", false);
                    introElem.fadeIn(150);
                } else {
                    introElem.hide();
                    introElem.find(":input").prop("disabled", true);
                }
            }
        };
    })(jQuery);
}
